/* eslint react/no-unused-prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from './input';

class KontoInput extends Component {

    static propTypes = {
        label: PropTypes.string,
        name: PropTypes.string,
        tooltipText: PropTypes.string,
        modalHelpBody: PropTypes.element,
        modalHelpHeader: PropTypes.string,
        infoLinkLabel: PropTypes.string,
        infoLinkText: PropTypes.string,
        errorText: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        onKeyUp: PropTypes.func,
        type: PropTypes.string
    };

    static defaultProps = {
        type: 'tel'
    };

    constructor(props) {
        super(props);
        const formattedValue = props.value && KontoInput.format(props.value);
        this.state = {
            formattedValue,
            value: formattedValue
        };
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    static format(value) {

        const reverse = (string) => {
            return string.split('').reverse().join('');
        };

        return value && reverse(reverse(value.toString()).replace(/(?=(\d{4})(?!\d))|(?=(\d{6})(?!\d))/g, ' '));
    }

    onBlur(event) {
        const formattedValue = KontoInput.format(this.state.value);
        this.setState({
            ...this.state,
            value: formattedValue
        });

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    }

    onFocus(event) {
        const unformattedValue = this.state.value && this.state.value.toString().replace(/ /g, '');
        this.setState({
            ...this.state,
            value: unformattedValue
        });

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }

    onChange(event) {
        const { value } = event.target;
        if ((!isNaN(Number(value.toString().replace(/ /g, ''))) && value.length < 12) || !value) {
            this.setState({
                ...this.state,
                value: event.target.value
            });

            if (this.props.onChange) {
                this.props.onChange(event);
            }
        }
    }

    render() {
        const {
            label,
            type,
            name,
            tooltipText,
            modalHelpBody,
            modalHelpHeader,
            infoLinkLabel,
            infoLinkText,
            errorText,
            onKeyUp,
            ...rest
        } = this.props;

        return (
            <Input
                {...rest}
                label={label}
                type={type}
                name={name}
                value={this.state.value}
                tooltipText={tooltipText}
                modalHelpBody={modalHelpBody}
                modalHelpHeader={modalHelpHeader}
                infoLinkLabel={infoLinkLabel}
                infoLinkText={infoLinkText}
                errorText={errorText}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                onKeyUp={onKeyUp}
            />
        );
    }

}

export default KontoInput;
